import { StreamingQuery } from 'dashboard-services/api/streaming';
import { CommonService } from 'dashboard-services/services';

import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

export default (() => {

  const useSearchCollections = ({ query, shouldBeLimited, getQueryBuilder, size = CommonService.getRequestSize(), enabled = true, shouldRefetch = true, ...rest }) => 
    useInfiniteQuery({
      ...StreamingQuery.QUERIES.search(
        getQueryBuilder
        ,
        {
          configKey: "prod",
          size,
          query
        }
      ),
      initialPageParam: 0,
      refetchInterval: () => !shouldRefetch || shouldBeLimited() ? undefined : 10000,
      getNextPageParam: CommonService.getNextPageParam,
      enabled,
      ...rest
    })

  const useGetCollection = ({ getQueryBuilder, id, ...rest }) =>
    useQuery({
      ...StreamingQuery.QUERIES.get(
        getQueryBuilder,
        {
          configKey: "prod",
          id
        }
      ),
      ...rest
    })

  const useUpdateCollection = ({ getQueryBuilder, data, id, groupName, metadata, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...StreamingQuery.QUERIES.update(
        getQueryBuilder,
        {
          configKey: "prod",
          data,
          groupName,
          id,
          metadata
        }
      ),
      onSuccess: response => {
        queryClient.invalidateQueries({ queryKey: StreamingQuery.KEYS.SEARCH() })
        onSuccess?.(response)
      },
      ...rest
    })

  const useDeleteCollection = ({ getQueryBuilder, id, onSuccess, queryClient, ...rest }) =>
    useMutation({
      ...StreamingQuery.QUERIES.delete(
        getQueryBuilder,
        {
          configKey: "prod",
          id
        }
      ),
      onSuccess: response => {
        queryClient.invalidateQueries({ queryKey: StreamingQuery.KEYS.SEARCH() })
        onSuccess?.(response)
      },
      ...rest
    })

  const useMassUpdateCollections = ({ getQueryBuilder, items, ...rest }) =>
    useMutation({
      ...StreamingQuery.QUERIES.createBatch(
        getQueryBuilder,
        {
          configKey: "prod",
          items
        }
      ),
      ...rest
    })

  const useTestStreaming = ({ getQueryBuilder, items, ...rest }) =>
    useMutation({
      ...StreamingQuery.QUERIES.testStreaming(
        getQueryBuilder,
        {
          items
        }
      ),
      ...rest
    })

  return {
    useSearchCollections,
    useGetCollection,
    useDeleteCollection,
    useUpdateCollection,
    useMassUpdateCollections,
    useTestStreaming
  }
})()
